<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span data-uk-icon="icon:users; ratio:1.2"></span>
            Händler
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div v-if="!loading">
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-body">
          <div class="uk-grid uk-grid-small uk-flex uk-flex-middle">
            <div class="uk-width-auto">
              <div class="uk-grid uk-grid-small uk-flex uk-flex-middle" data-uk-grid>
                <div class="uk-width-medium@m">
                  <merchant-search></merchant-search>
                </div>
              </div>
            </div>
            <div class="uk-width-auto">
              <router-link
                class="uk-button uk-button-primary uk-button-small"
                :to="{ name: 'admin.merchant.create' }"
              >
                <span data-uk-icon="plus-circle"></span>
                Neuen Händler anlegen
              </router-link>
            </div>
            <div class="uk-width-expand" v-if="meta && meta.pagination.total_pages > 1">
              <pagination :pagination="meta.pagination" @pagination:switched="onPaginationSwitch"></pagination>
            </div>
          </div>
          <div class="uk-overflow-auto">
            <table
              class="uk-table uk-table-middle uk-table-hover uk-table-divider"
              v-if="merchants && merchants.length"
            >
              <thead>
                <tr>
                  <th class="uk-table-shrink">#</th>
                  <th class="uk-table-expand">Firma</th>
                  <!--<th class="uk-table-expand">Ansprechpartner</th>-->
                  <th class="uk-width-small">Telefon</th>
                  <th class="uk-width-small">E-Mail</th>
                  <th class="uk-table-shrink uk-text-center">Status</th>
                  <th class="uk-table-shrink uk-text-center uk-text-nowrap" v-if="tenant.knumber === 'K10149'">DMS</th>
                  <th class="uk-table-shrink uk-text-right">Registriert</th>
                  <th class="uk-table-shrink uk-text-center uk-text-nowrap">Letzter Login</th>
                  <th style="width: 25px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="merchant in merchants" :key="merchant.id">
                  <td>{{ merchant.number }}</td>
                  <td class="uk-text-truncate">
                    <router-link
                      :to="{ name: 'admin.merchant.details', params: { id: merchant.id } }"
                    >
                      {{ merchant.company }}
                    </router-link>
                    <div v-if="tenant.knumber === 'K10151' && merchant.lastSale">
                      Letzter Kauf: {{ merchant.lastSale.data.date }}
                    </div>
                  </td>
                  <!--
                  <td>
                    {{ merchant.salutation }} {{ merchant.firstname }} {{ merchant.lastname }}
                  </td>
                  -->
                  <td class="uk-text-nowrap">
                    {{ merchant.phone }}
                  </td>
                  <td class="uk-text-nowrap">
                    {{ merchant.email }}
                  </td>
                  <td class="uk-text-center uk-text-nowrap">
                    <div v-if="working(merchant.id)" data-uk-spinner="ratio: 0.6"></div>
                    <a
                      v-else
                      href="#"
                      @click.prevent="setStatus(merchant.id)"
                      :style="{
                        color: merchant.active ? '#228c3a' : '#dc3545',
                        'margin-right': '2px'
                      }"
                    >
                      <svg
                        viewBox="0 0 120 120"
                        version="1.1"
                        style="width:20px"
                        fill="currentcolor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="60" cy="60" r="50" />
                      </svg>
                    </a>
                  </td>
                  <td class="uk-text-right uk-text-nowrap" v-if="tenant.knumber === 'K10149'">
                    <span
                      :style="{
                        color: isMerchantLinkedToDms(merchant) ? '#228c3a' : '#dc3545',
                        'margin-right': '2px'
                      }"
                      :data-uk-tooltip="isMerchantLinkedToDms(merchant) ? 'DMS Geschäftspartner verknüpft' : 'DMS Geschäftspartner noch nicht verknüpft'"
                    >
                      <svg
                        viewBox="0 0 120 120"
                        version="1.1"
                        style="width:20px"
                        fill="currentcolor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="60" cy="60" r="50" />
                      </svg>
                    </span>
                  </td>
                  <td class="uk-text-right uk-text-nowrap">{{ merchant.created }}</td>
                  <td class="uk-text-right uk-text-nowrap">{{ merchant.lastLogin || '-' }}</td>
                  <td class="uk-text-nowrap">
                    <div class="uk-text-right">
                      <a href="#" class="uk-icon-link" uk-icon="more"></a>
                      <div data-uk-dropdown="mode: click;animation: uk-animation-slide-top-small;">
                        <ul class="uk-nav uk-dropdown-nav uk-text-left">
                          <li>
                            <a
                              class="uk-dropdown-close"
                              href="#"
                              @click.prevent="setStatus(merchant.id)"
                            >
                              <span v-if="merchant.active">Deaktivieren</span>
                              <span v-else>Aktivieren</span></a
                            >
                          </li>
                          <li>
                            <router-link
                              class="uk-dropdown-close"
                              :to="{ name: 'admin.merchant.details', params: { id: merchant.id } }"
                              >Details</router-link
                            >
                          </li>
                          <li class="uk-nav-divider"></li>
                          <li>
                            <a href="#" class="uk-text-danger uk-dropdown-close" @click.prevent="remove(merchant.id)">
                              <span data-uk-icon="icon: trash; ratio: 0.8"></span>
                              Löschen
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="!merchants.length" class="uk-margin uk-text-large">
            Keine Händler vorhanden!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MerchantService from '@/services/merchant.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import Pagination from '@/components/Pagination'
import MerchantSearch from '@/components/MerchantSearch'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      merchants: [],
      meta: null,
      loading: true,
      workingIds: []
    }
  },
  components: {
    Pagination,
    MerchantSearch
  },
  mounted() {
    this.getList()
  },
  watch: {
    '$route.query'() {
      this.getList()
    }
  },
  computed: {
    ...mapGetters(['tenant'])
  },
  methods: {
    async getList() {
      const response = await MerchantService.getAll({ ...this.$route.query })
      this.merchants = response.data.data
      this.meta = response.data.meta
      this.loading = false
    },
    async setStatus(id) {
      this.workingIds.push(id)
      await MerchantService.setStatus(id)
      setTimeout(() => {
        iziToast.success({
          title: 'OK',
          message: 'Händler Status geändert!',
          timeout: 3000,
          position: 'topCenter'
        })
        this.workingIds = this.workingIds.filter(value => {
          return value !== id
        })
        this.getList()
      }, 1000)
    },
    isMerchantLinkedToDms(merchant) {
      return merchant.dms_customer_id && !merchant.dms_customer_id.startsWith('INT')
    },
    remove(id) {
      const $this = this
      this.$uikit.modal
        .confirm('<h3><strong>Händler wirklich löschen?</strong></h3><p class="uk-text-danger uk-margin-remove">Achtung: Alle Einstellungen und Angebote des Händlers werden ebenfalls gelöscht!</p><p>Käufe bleiben gespeichert!</p>', {
          labels: {
            cancel: 'Abbrechen',
            ok: 'Löschen'
          }
        })
        .then(function() {
          MerchantService.delete(id)
            .then(() => {
              $this.getList()
              iziToast.success({
                title: 'OK',
                message: 'Händler gelöscht!',
                timeout: 3000,
                position: 'topCenter'
              })
            })
            .catch(() => {
              iziToast.error({
                title: 'OK',
                message: 'Löschen fehlgeschlagen!',
                timeout: 3000,
                position: 'topCenter'
              })
            }),
            function() {
              //
            }
        })
    },
    working(id) {
      return this.workingIds.includes(id)
    },
    onPaginationSwitch(page) {
      this.addParamsToLocation({ page: page })
      this.$route.query.page = page
      this.getList()
    },
    addParamsToLocation(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
        '?' +
        Object.keys(params)
          .map(key => {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            )
          })
          .join('&')
      )
    }
  }
}
</script>
